module.exports = __webpack_public_path__ + "img/packaged.216aa1aa.png";